export default "__VITE_ASSET__ca04d211__"